import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7545db8d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.url,
    class: "nav-button mt-2 lg:mt-0 md:mt-0 lg:text-2xl md:text-xl font-expanded text-white"
  }, _toDisplayString(_ctx.title), 9, _hoisted_1))
}